import React from "react"
import Typography from "aldoo-ra/Typography"
import ReadTimeBadge from "./read-time-badge"
import PageLike from "./page-like"

const PostCard = ({ post }) => {
  const href = `/blog/${post.slug}`
  // const borderStyle = post.border ? "border-[1px] border-bordered" : ""

  const formatDate = (dateString) => {
    const date = new Date(dateString || "2024-10-23")
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  }

  return (
    <a href={href} className="flex flex-col h-auto bg-neutral_1/30 hover:bg-neutral_1/50 rounded-[16px] lg:rounded-[24px] p-3 cursor-pointer group transition-all">
      {/* Image Container */}
      <div className={`relative w-full aspect-[2.07] rounded-[12px] lg:rounded-[20px] overflow-hidden bg-neutral_1 mb-4 md:mb-7 border border-bordered`}>
        <ReadTimeBadge data={post} top="4" topMd="4" right="4" rightMd="5" />

        <img
          src={post.thumbnail}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>

      {/* Content */}
      <div className="flex flex-col md:gap-4">
        <div className="flex items-center justify-between">
          <Typography
            variant="txt1_dim"
            className="my-0"
          >
            {formatDate(post.publish_date)}
          </Typography>

          <PageLike target={post} />
        </div>

        <Typography
          component="h3"
          variant="body2_accent"
          className="my-0"
        >
          {post.title}
        </Typography>
      </div>
    </a>
  )
}

export default PostCard
